import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import type { PayrollPriceAmounts } from './payrollPrice.types'

type PayrollPriceState = PayrollPriceAmounts | null

const payrollPriceSlice = createSlice({
  name: 'payrollPrice',
  initialState: null as PayrollPriceState,
  reducers: {
    receivePayrollPrices: (_, action: PayloadAction<PayrollPriceAmounts>) =>
      action.payload,
  },
})

export const { receivePayrollPrices } = payrollPriceSlice.actions

export default payrollPriceSlice.reducer
